import React, { Fragment } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import {
  Box,
  FormControl,
  FormControlLabel,
  Switch,
  Typography,
  Hidden,
  Divider,
} from '@mui/material'

import { MUI } from 'components'

import { BannerConfigurationSchemaType } from 'types/banner.types'

import { theme } from 'theme'

const PrivacyPortalCustomization = () => {
  const { control } = useFormContext<BannerConfigurationSchemaType>()

  return (
    <Fragment>
      <Box display="flex" flexDirection="column" gap={2}>
        <Controller
          name="privacyPortalEnabled"
          control={control}
          render={({ field }) => (
            <FormControl>
              <MUI.FormLabel $fontWeight={600}>
                Configuração do Canal de Atendimento ao Titular de Dados
              </MUI.FormLabel>
              <FormControlLabel
                control={
                  <Switch
                    {...field}
                    checked={field.value || false}
                    color="primary"
                  />
                }
                label="Habilitar Canal de Atendimento ao Titular de Dados"
              />
            </FormControl>
          )}
        />

        <Box mt={2} p={4} bgcolor={theme.palette.custom.light} borderRadius={1}>
          <Typography color="primary" fontWeight={600} gutterBottom>
            Informação
          </Typography>
          <Typography color="primary" textAlign="justify">
            O Canal de Atendimento ao Titular de Dados permite que seus usuários
            tenham acesso completo às configurações de privacidade e cookies do
            seu site, oferecendo maior transparência e controle sobre seus dados
            pessoais.
          </Typography>
        </Box>
      </Box>
      <Hidden xlDown>
        <Divider orientation="vertical" variant="middle" flexItem />
      </Hidden>
    </Fragment>
  )
}

export default PrivacyPortalCustomization
